import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import ContentCard from "Components/shared/ContentCard";
import { Box, Typography } from "@mui/material";
import LoadingBanner from "Components/shared/LoadingBanner";
import { useRTL } from "hooks/isRTL";
import { getSenderContacts } from "services/customerManagement";
import { fallbackValue } from "constants/fallbackConstant";

const ContactDetailsTab = () => {
  const { senderId } = useParams();
  const { t } = useRTL();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["senderContacts", senderId],
    queryFn: () => getSenderContacts(senderId),
    enabled: !!senderId,
  });

  if (isLoading)
    return <LoadingBanner isLoading={true} message={t("loading")} />;
  if (isError)
    return (
      <Typography color="error">{t("Failed to load contacts")}</Typography>
    );

  const contacts = data.data.page;
  return (
    <Box sx={{ padding: "1rem" }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
        {t("contactsInformation")}
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gap: 2,
        }}
      >
        {contacts.map((contact) => {
          const content = [
            { label: t("contactName"), value: contact.fullName || fallbackValue },
            {
              label: t("contactPersonMopileNumber"),
              value: contact.phoneNumber.replace("_", "") || fallbackValue,
            },
            { label: t("occupation"), value: contact.occupation || fallbackValue },
            {
              label: t("isActive"),
              value: contact.isActive ? t("active") : t("inactive"),
            },
          ];
          return <ContentCard key={contact.id} content={content} />;
        })}
      </Box>
    </Box>
  );
};

export default ContactDetailsTab;
